import { SaleConvertRes } from 'services/api/dashboard';
import { sortByDate } from '../../utils';

export default function convertData(
  input: Partial<SaleConvertRes>,
): Partial<Dashboard.SaleConvertInner> {
  const { consult, orderReminder, purchaseReminder, paymentReminder, preConsult } = input;
  return {
    /** 咨询转化 */
    整体咨询: {
      咨询买家人数: consult?.consultBuyerCount,
      咨询后下单买家人数: consult?.consultBuyerIsConvertCount,
      咨询转化订单量: consult?.consultConvertOrderCount,
      咨询转化订单总额: consult?.consultConvertOrderAmount?.currencyToAmount,
      咨询转化率: consult?.consultRate,
      咨询转化领先率: consult?.overallBeatRatio,
      每日咨询转化: sortByDate(consult?.consultDataOfDays)?.map((item) => {
        const { date, consultBuyerCount, consultBuyerIsConvertCount, consultRate } = item;
        return {
          date,
          咨询买家数: consultBuyerCount,
          咨询后下单买家数: consultBuyerIsConvertCount,
          咨询转化率: consultRate,
        };
      }),
    },
    售前咨询: {
      咨询买家人数: preConsult?.consultBuyerCount,
      咨询后下单买家人数: preConsult?.consultBuyerIsConvertCount,
      咨询转化订单量: preConsult?.consultConvertOrderCount,
      咨询转化订单总额: preConsult?.consultConvertOrderAmount?.currencyToAmount,
      咨询转化率: preConsult?.consultRate,
      咨询转化领先率: preConsult?.overallBeatRatio,
      每日咨询转化: sortByDate(preConsult?.consultDataOfDays)?.map((item) => {
        const { date, consultBuyerCount, consultBuyerIsConvertCount, consultRate } = item;
        return {
          date,
          咨询买家数: consultBuyerCount,
          咨询后下单买家数: consultBuyerIsConvertCount,
          咨询转化率: consultRate,
        };
      }),
    },

    /**  催单转化 */
    催单买家人数: orderReminder?.orderReminderBuyerCount,
    催单后下单买家人数: orderReminder?.orderReminderBuyerIsConvertCount,
    催单转化率: orderReminder?.orderReminderRate,
    催单转化领先率: orderReminder?.overallBeatRatio,
    催单转化订单量: orderReminder?.orderReminderConvertCount,
    催单转化订单总额: orderReminder?.orderReminderConvertAmount?.currencyToAmount,
    每日催单转化: sortByDate(orderReminder?.orderReminderOfDays)?.map((item) => {
      const { date, orderReminderBuyerCount, orderReminderBuyerIsConvertCount, orderReminderRate } =
        item;
      return {
        date,
        催单买家人数: orderReminderBuyerCount,
        催单后下单买家人数: orderReminderBuyerIsConvertCount,
        催单转化率: orderReminderRate,
      };
    }),

    /**  催促购买转化 */
    催促购买买家人数: purchaseReminder?.purchaseReminderBuyerCount,
    催促购买后下单买家人数: purchaseReminder?.purchaseReminderConvertBuyerCount,
    催促购买转化率: purchaseReminder?.purchaseReminderConvertRate,
    催促购买转化领先率: purchaseReminder?.overallBeatRatio,
    催促购买转化订单量: purchaseReminder?.purchaseReminderConvertTradeCount,
    催促购买转化订单总额: purchaseReminder?.purchaseReminderConvertTradeAmount?.currencyToAmount,
    每日催促购买转化: sortByDate(purchaseReminder?.purchaseReminderOfDays)?.map((item) => {
      const {
        date,
        purchaseReminderBuyerCount,
        purchaseReminderConvertBuyerCount,
        purchaseReminderConvertRate,
      } = item;
      return {
        date,
        催促购买买家人数: purchaseReminderBuyerCount,
        催促购买后下单买家人数: purchaseReminderConvertBuyerCount,
        催促购买转化率: purchaseReminderConvertRate,
      };
    }),

    /**  非COD催付转化 */
    催付订单量: paymentReminder?.paymentReminderTradeCount,
    催付后成功订单呢量: paymentReminder?.paymentReminderTradeSuccessCount,
    催付转化率: paymentReminder?.paymentReminderTradeRate,
    催付转化领先率: paymentReminder?.overallBeatRatio,
    催付转化订单总额: paymentReminder?.paymentReminderTradeIsConvertAmount?.currencyToAmount,
    每日催付转化: sortByDate(paymentReminder?.paymentReminderOfDays)?.map((item) => {
      const {
        date,
        paymentReminderTradeCount,
        paymentReminderTradeSuccessCount,
        paymentReminderTradeRate,
      } = item;
      return {
        date,
        催付订单量: paymentReminderTradeCount,
        催付成功订单量: paymentReminderTradeSuccessCount,
        催单转化率: paymentReminderTradeRate,
      };
    }),
  };
}
